<template>
  <div>
    <slot name="botao-ativador" :callbackAbrirDialog="abrirDialog">

    </slot>

    <SysDialog
      v-model="dialog_ativo"
      titulo="Silenciar notificação do produto"
      :largura="700"
      @click:primary="salvarSilenciamentoProdutos"
      @click:hidden-dialog="fecharDialog"
    >
      <div class="pt-1 pb-3">
        <v-radio-group
          class="dataradio"
          label="Silenciar o Produto Até*"
          hide-details
          v-model="periodo_fixos_selecionado"
        >
          <v-row>
            <v-col col="2">
              <v-radio label="1 semana" :value="7"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="1 mês" :value="30"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="2 meses" :value="60"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="3 meses" :value="90"></v-radio>
            </v-col>

            <v-col col="2">
              <v-radio label="6 meses" :value="180"></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>

        <v-text-field
          v-model="data_limite"
          outlined
          type="date"
          @focus="periodo_fixos_selecionado = null"
          :error-messages="getMensagensValidacao('data_limite')"
        />

        <v-autocomplete
          v-model="motivos"
          :items="selects.motivos"
          class="autocomplete-motivo"
          item-value="id"
          item-text="descricao"
          label="Motivos de Silenciar o Produto"
          outlined
          chips
          small-chips
          multiple
          :error-messages="getMensagensValidacao('motivos')"
        />

        <div class="pb-5" v-if="compra_por_filial_habilitada && !editando">
          <v-radio-group
            hide-details
            v-model="silenciar_geral"
          >
            <v-radio :value="false">
              <template #label>
                <span class="pl-1">Silenciar somente {{FILIAL_COMPRA > 0 ? 'na filial' : 'no grupo'}}</span>
              </template>
            </v-radio>

            <v-radio :value="true" class="mt-1">
              <template #label>
                <span class="pl-1">Silenciar em todas as filiais do grupo</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <div class="pl-1">
          <h4>Você pode silenciar o produto de 3 maneiras:</h4>

          <ul>
            <li>Por uma semana marcando a opção correspondente</li>
            <li>De 1 a 6 meses marcando a opção correspondente</li>
            <li>Informando uma data específica. Ex: 01/01/2021</li>
          </ul>
        </div>
      </div>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import {buscarMotivosSilenciamentoProduto, salvarSilenciamentoProdutos} from "@/api/compraPorProdutosGerais/NotificacaoBlackList";
import {logout} from "@/helpers";
import {required} from "vuelidate/lib/validators";

export default {
  name: "SilenciarProdutosDialog",
  components: {
    SysDialog
  },
  props: {
    produtos: Array,
    editando: Boolean
  },
  data: () => ({
    dialog_ativo: false,
    periodo_fixos_selecionado: null,
    data_limite: '',
    motivos: [],
    silenciar_geral: false,
    compra_por_filial_habilitada: localStorage.filial_compra === 'S',
    selects: {
      motivos: []
    }
  }),
  validations: {
    data_limite: {
      required,
      data_limite_valida: function () {
        return new Date(this.data_limite) > new Date();
      }
    },
    motivos: {
      required,
    }
  },
  computed: {
    FILIAL_COMPRA() {
      return this.$store.getters['usuario/getFilialCompras'];
    }
  },
  watch: {
    periodo_fixos_selecionado() {
      if (!this.periodo_fixos_selecionado) return;

      const data_atual = new Date();
      data_atual.setDate(parseInt(this.periodo_fixos_selecionado) + data_atual.getDate());

      const dia = String(data_atual.getDate()).padStart(2, '0');
      const mes = String(data_atual.getMonth() + 1).padStart(2, '0');
      this.data_limite = `${data_atual.getFullYear()}-${mes}-${dia}`;
    }
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v[campo].$dirty) return [];

      if ((this.$v[campo].$params.required !== undefined) && !this.$v[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v[campo].$params.data_limite_valida !== undefined) && !this.$v[campo].data_limite_valida) {
        return  ["Data deve ser maior que hoje."];
      }

      return [];
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.buscarMotivos();

      if (this.editando) {
        this.setDadosEdicao();
      }
    },
    buscarMotivos() {
      if (this.selects.motivos.length > 0) {
        return;
      }

      this.$store.dispatch('loading/addRequisicao',
        buscarMotivosSilenciamentoProduto()
          .then(motivos => this.selects.motivos = motivos)
          .catch(logout)
      );
    },
    salvarSilenciamentoProdutos() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const callback = produto => ({
        id: produto.id,
        grupo: produto.id_grupo,
        filial: produto.filial || 0,
        produto: produto.idproduto,
        produto_eh_combinacao: produto.produto_eh_combinacao,
      });

      const parametros = {
        motivos: this.motivos,
        data_limite: this.data_limite,
        produtos: this.produtos.map(callback),
        silenciar_geral: this.silenciar_geral
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarSilenciamentoProdutos(parametros)
          .then(() => {
            this.$emit('update:produtos-silenciados', {produtos: this.produtos});
            this.fecharDialog();
          })
          .catch(logout)
      );
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.periodo_fixos_selecionado = null;
      this.data_limite = '';
      this.motivos = [];
      this.silenciar_geral = false;
    },
    setDadosEdicao() {
      const [produto_edicao] = this.produtos;
      this.data_limite = produto_edicao.data_limite.split('/').reverse().join('-');
      this.motivos = JSON.parse(produto_edicao.ids_motivos);
    }
  }
}
</script>

<style scoped>

</style>
